var map = {
	"./block-banner/block-banner.js": "../modules/block-banner/block-banner.js",
	"./block-document/block-document.js": "../modules/block-document/block-document.js",
	"./block-gallery/block-gallery.js": "../modules/block-gallery/block-gallery.js",
	"./block-other-product/block-other-product.js": "../modules/block-other-product/block-other-product.js",
	"./block-other/block-other.js": "../modules/block-other/block-other.js",
	"./block-partner/block-partner.js": "../modules/block-partner/block-partner.js",
	"./block-product/block-product.js": "../modules/block-product/block-product.js",
	"./block-search/block-search.js": "../modules/block-search/block-search.js",
	"./block-service/block-service.js": "../modules/block-service/block-service.js",
	"./p-history/p-history.js": "../modules/p-history/p-history.js",
	"./product-gallery/product-gallery.js": "../modules/product-gallery/product-gallery.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../modules sync recursive ^\\.\\/.*\\/.*\\.js$";